<template>
  <div class="news_detail_wrap">
    <div class="news_detail">
      <page-header class="not_main"></page-header>
      <div class="news_detail_content">

        <image-component :infoType="'newsBanner'"></image-component>

        <div class="news_detail_content_box">

          <board-detail-component :boardType="`newsDetail`" :boardKey="boardKey"></board-detail-component>

<!--          <div class="news_detail_content_box_bottom">-->
<!--            <button class="news_detail_content_box_bottom_backBtn" @click="backEvent()">목록</button>-->
<!--          </div>-->
        </div>
      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>
import BoardDetailComponent from "@/components/board/BoardDetailComponent";
import ImageComponent from "@/components/information/ImageComponent";

export default {
  name: "NewsDetail",
  mixins: [],
  components: {ImageComponent, BoardDetailComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      boardKey: ''
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.getBoardKey()
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getBoardKey() {
      this.boardKey = this.$route.params.wr_id
    },
    backEvent() {
      this.$router.back();
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>